import React, {useCallback} from 'react'
import {useChatStore} from '@components/right-panel/chat/chat-store'
import {useRightPanelContentStore} from '@components/right-panel/right-panel-content/right-panel-content-store'
import {MessageUtils} from '@extensions/message-utils'

export const usePreview = (): ((href: string, e: React.MouseEvent) => void) => {
  const [, store] = useChatStore()
  const [, rightPanelStore] = useRightPanelContentStore()

  return useCallback(
    (href, e) => {
      if (href.startsWith('/user-data/')) {
        const links = MessageUtils.getMessagesLinks(store.getAllMessagesList())
        rightPanelStore.setSelectedFilesToView(
          MessageUtils.getFileViewData(links),
          MessageUtils.getLinkIndex(links, href)
        )
        e.preventDefault()
      }
    },
    [store, rightPanelStore]
  )
}
